import { createBrowserRouter } from 'react-router';

import { AppLayout } from '@layouts/AppLayout';
import { HomePage } from '@pages/HomePage';

/**
 * Routing.
 *
 * AppLayout is a layout route wrapping every page, so the header, footer
 * and ambient background mount once and survive navigation; only the
 * Outlet changes.
 *
 * Home is bundled eagerly because it is where most visits begin. Every
 * other page is its own chunk, fetched on first navigation. The router
 * resolves a lazy route before committing, so there is no loading flash.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    Component: AppLayout,
    children: [
      { index: true, Component: HomePage },
      {
        path: 'services',
        lazy: async () => ({ Component: (await import('@pages/ServicesPage')).ServicesPage }),
      },
      {
        path: 'work',
        lazy: async () => ({ Component: (await import('@pages/WorkPage')).WorkPage }),
      },
      {
        path: 'about',
        lazy: async () => ({ Component: (await import('@pages/AboutPage')).AboutPage }),
      },
      {
        path: 'contact',
        lazy: async () => ({ Component: (await import('@pages/ContactPage')).ContactPage }),
      },
      {
        path: '*',
        lazy: async () => ({ Component: (await import('@pages/NotFoundPage')).NotFoundPage }),
      },
    ],
  },
]);
